import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Envio.types';
import * as Pedidos from '../Pedidos';
import { IEnvio } from './Envio.lib';
import * as Types from './Envio.types';
import { Pedido } from '../Pedidos';
import { Utiles } from '@/__env/pluggins/event-bus';

export class Envio extends IEnvio
{

    public static async create( id: number ): Promise<Envio>
    {
        let o = new Envio();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/envios';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.params.details = 'empresa_logistica';
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Envio>; Error?: boolean; }>
    {

        let a: Array<Envio> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/envios` );
        request.params = params;
        request.params.details = 'empresa_logistica';
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Envio( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public static async AbrirEtiqueta( ped: Pedido | Pedido[] )
    {
        const ids = Array.isArray(ped) ? ped.map(x=> x.Id) : [ped.Id];
        const url = await Envio.DescargarEtiquetas(ids)
        if ( url )
        {
            window.open( url );
        } else
        {
            Utiles.Notificaciones.Error( `Etiquetas no encontradas!` );
        }
    }
 

    private static async DescargarEtiquetas( ids: any[] ): Promise<string>
    {
        let request = new apiRequest( `/envios/etiquetas/descargar` );
        request.params = { ids: ids.join( ',' ) };
        request.timeOut = 99999999999999999;
        if ( await request.get() )
        {
            return request.data.url;
        }
    }

    public async CancelarEnvioPickit()
    {
        try
        {
            let req = new apiRequest();
            req.path = `/envios/${this.Id}/pickit/${this.Cuenta}/${this.IdExterna}`;
            if ( await req.delete() )
            {
                this.Plataforma = Types.Plataformas.Propia;
                this.Tipo = Types.Tipos.NoEspecificado;
                return true;
            }

        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async crearRepartoTreggo( cuenta: string )
    {

        let js = this.getJson();
        js.crear_treggo = 'S';
        js.cuenta_treggo = cuenta;

        try
        {
            let req = new apiRequest();
            req.body = js;
            req.path = `${this.Route}/${this.Id}`;
            if ( await req.put() )
            {
                this.Json = req.data;
                return this.set();
            }

        } catch ( e )
        {
            Log( e );
        }
        return false;
    }


    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    return this.set();
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    return this.set();
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async eliminarEtiqueta(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}/etiqueta`;
                if ( await req.delete() )
                {
                    this.Etiqueta = '';
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }
    public async guardarEtiqueta( Archivo: any ): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.useformData = true;
                req.formData.append( 'file', Archivo );
                req.path = `${this.Route}/${this.Id}/etiqueta`;
                if ( await req.post() )
                {
                    this.Etiqueta = req.data.url;
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async cargarSeguimiento(): Promise<string>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}/seguimiento`;
                if ( await req.get() )
                {
                    console.log( req );
                    return req.data;
                }
            }

        } catch ( e )
        {
            Log( e );
        }

        return '';
    }


    public async Entregar(): Promise<string>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                req.body = {};
                req.body.estado = 'entregado';
                req.body.avisar_plataforma = 'S';
                if ( await req.put() )
                {
                    this.Estado = Pedidos.Estados.Entregado;
                    return req.data;
                }
            }

        } catch ( e )
        {
            Log( e );
        }

        return '';
    }
}